module.exports = __webpack_public_path__ + "img/fish.04bbaff6.png";